import { render, staticRenderFns } from "./official.vue?vue&type=template&id=612b3362&scoped=true&"
import script from "./official.vue?vue&type=script&lang=js&"
export * from "./official.vue?vue&type=script&lang=js&"
import style0 from "./official.vue?vue&type=style&index=0&id=612b3362&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b3362",
  null
  
)

export default component.exports